import { ICellRendererParams } from '@ag-grid-community/core'
import { DataTable, DataTablePagination } from 'components/common'
import { usePageAccess, useQuery } from 'hooks'
import useModal from 'hooks/useModal'
import { useEffect, useMemo, useState } from 'react'
import { useLocation } from 'react-router-dom'
import { fetchPendingErpSyncRma } from 'utils/api/pendingErpSyncApi'
import { getPendingErpSyncRmaColumns } from './utils'
import ConfirmResyncOrderModal from './confirmResyncOrderModal'

const PendingErpSyncRmaTable = () => {
  const [rmaData, setOrdersData] = useState<any>({})
  const [loading, setLoading] = useState<boolean>(false)

  const [gridParams, setGridParams] = useState<ICellRendererParams>()

  const { search } = useLocation()
  const { getAllQueries } = useQuery()
  const { closeModal, isOpen, openModal } = useModal()
  const { isEditor } = usePageAccess()

  const getRmas = async () => {
    setLoading(true)
    const { limit, search: searchTerm, page } = getAllQueries()
    try {
      const { data } = await fetchPendingErpSyncRma({
        limit: limit || 10,
        page: page || 1,
        search: searchTerm,
      })
      setOrdersData(data)
    } catch (error) {
      setOrdersData({ docs: [] })
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    getRmas()
  }, [search])

  // Store the row params and open the confirmation modal
  const handleOpenResyncModal = (params: ICellRendererParams) => {
    setGridParams(params)
    openModal()
  }

  const columns = useMemo(
    () => getPendingErpSyncRmaColumns(handleOpenResyncModal, isEditor),
    [isEditor],
  )

  return (
    <>
      <DataTable
        columns={loading ? [] : columns}
        rows={loading ? null : rmaData?.docs}
        identifier="rmaNo"
      />

      {/* Confirm Resync Modal */}
      <ConfirmResyncOrderModal
        type="rma"
        params={gridParams}
        closeModal={closeModal}
        isOpen={isOpen}
      />

      <DataTablePagination
        currentPage={rmaData?.page}
        totalPages={rmaData?.totalPages}
        hasNextPage={rmaData?.hasNextPage}
        hasPrevPage={rmaData?.hasPrevPage}
        limit={rmaData?.limit}
        nextPage={rmaData?.nextPage}
        prevPage={rmaData?.prevPage}
      />
    </>
  )
}

export default PendingErpSyncRmaTable
